import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { configureOfflineReopen, attachOfflineReopenClient } from './offline-reopen';

// Optional chaining keeps persistence-only offline probes loadable under
// plain Node, where Vite has not injected import.meta.env. Browser builds see
// the same values and keep the same eager initialization behavior.
const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL ?? '';
const SUPABASE_ANON_KEY = import.meta.env?.VITE_SUPABASE_ANON_KEY ?? '';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (client) return client;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return null;
  const observedFetch = configureOfflineReopen(SUPABASE_URL);
  client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY,
    observedFetch ? { global: { fetch: observedFetch } } : undefined);
  attachOfflineReopenClient(client);
  return client;
}
